import { useLocation } from '@reach/router'

export function useSearchParams() {
  const location = useLocation()

  return {
    search: location.search,
    searchParams: new URLSearchParams(location.search)
  }
}
